export default __webpack_public_path__ + "static/media/face.b8cd81f5.png";